import { STUDENT_ADDRESS_VALIDATORS, USER_VALIDATORS } from '@evidia/shared';
import { createSchemaFieldRule } from 'antd-zod';
import { z } from 'zod';
import { Field } from './components/SimpleForm';

// student
export const RULE_STUDENT_FIRST_NAME = createSchemaFieldRule(z.object({ firstName: USER_VALIDATORS.firstName.in }));

export const RULE_STUDENT_LAST_NAME = createSchemaFieldRule(z.object({ lastName: USER_VALIDATORS.lastName.in }));

export const RULE_STUDENT_ADDRESS_POST_CODE = createSchemaFieldRule(
	z.object({ postCode: STUDENT_ADDRESS_VALIDATORS.postCode.in }),
);

// Student address
export const STUDENT_ADDRESS_FIELDS: Field[] = [
	{
		key: 'street',
		label: 'Ulice',
		type: 'string',
		required: true,
		placeholder: 'Pecháčkova',
		rules: [{ required: true, message: 'Prosím zadejte ulici!' }],
	},
	{
		key: 'streetCode',
		label: 'Číslo popisné',
		type: 'string',
		required: true,
		placeholder: '435',
		rules: [{ required: true, message: 'Prosím zadejte číslo popisné!' }],
	},
	{
		key: 'city',
		label: 'Město',
		type: 'string',
		required: true,
		placeholder: 'Praha',
		rules: [{ required: true, message: 'Prosím zadejte město!' }],
	},
	{
		key: 'postCode',
		label: 'PSČ',
		type: 'string',
		required: true,
		placeholder: '14100',

		rules: [RULE_STUDENT_ADDRESS_POST_CODE],
	},
];
